<!--  *************************  -->
<!--       ROUTER HANDLER        -->
<!--  *************************  -->

<div [style.opacity]="viewReady? 1 : 0" class="absoluteFill">
  <dx-load-panel
    class="spinner-container"
    [class.no-pointer-events]="spinnerService.activeHTTPRequests === 0"
    *ngIf="viewReady "
    [shading]="true"
    message="{{ 'COMMON.LOADING' | translate }}"
    [(visible)]="spinnerService.showSpinner">
    <dxo-animation>
      <dxo-hide type="fadeOut"/>
      <dxo-show type="fadeIn" [duration]="100"/>
    </dxo-animation>
  </dx-load-panel>

  <router-outlet></router-outlet>
</div>
